<template>
  <div>
    <v-expansion-panels v-model="isExpanded">
      <v-expansion-panel>
        <v-expansion-panel-header disable-icon-rotate style="border: 1px solid #e6e4eb; background-color: white">
          {{ groupMark.title }}
          <template v-slot:actions>
            <div class="d-flex justify-end">
              <CardActions
                renameTitle="Đổi tên nhóm"
                deleteTitle="Xóa nhóm"
                @onRename="() => $refs['rename-popup'].openPopup(groupMark)"
                @onDelete="() => $refs['delete-popup'].openPopup(groupMark)"
              />
              <v-icon color="primary">{{ isExpanded === 0 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
            </div>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pt-3">
          <v-row>
            <v-col
              v-for="(mark, index) in groupMark.children"
              cols="4"
              :key="mark.id"
              :class="{ 'pl-0': index % 3 !== 0 }"
            >
              <CardView :mark="mark" />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <PopupEdit
      ref="rename-popup"
      popupTitle="Sửa tên nhóm đầu điểm"
      formLabel="Tên nhóm đầu điểm"
      formPlaceholder="Nhập tên nhóm đầu điểm"
      messageSuccess="Cập nhật tên nhóm đầu điểm thành công"
      @onRefresh="$emit('onRefresh')"
    />
    <PopupDeleteGroup ref="delete-popup" @onRefresh="$emit('onRefresh')" />
  </div>
</template>
<script>
import CardActions from './CardActions'
import CardView from './CardView.vue'
import PopupDeleteGroup from './PopupDeleteGroup.vue'
import PopupEdit from './PopupEdit.vue'
export default {
  components: {
    CardActions,
    CardView,
    PopupEdit,
    PopupDeleteGroup,
  },
  props: {
    groupMark: Object,
  },
  data() {
    return {
      isExpanded: 0,
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .v-expansion-panel:before {
    box-shadow: none;
  }
  .v-expansion-panel-content__wrap {
    padding: 0;
    padding-left: 24px;
    background-color: #f8f8f8;
  }
  .v-expansion-panel {
    background-color: #f8f8f8 !important;
  }
}
</style>
